import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../shared/services/superadminusers/auth.service';
import { getTokenData } from '../shared/services/utils/utils';

@Injectable({
    providedIn: 'root',
})
export class PortalAuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        // Check if the user is logged in
        if (!this.authService.isPortalUserLoggedIn()) {
            this.router.navigate(['/login']);
            return false;
        }

        const requiredRoles = route.data['roles'] as Array<string>;
        const tokenData = getTokenData();

        if (!tokenData) {
            this.router.navigate(['/access-denied']);
            return false;
        }

        const userRole = tokenData?.role;

        // If no roles specified, allow access
        if (!requiredRoles || requiredRoles.length === 0) {
            return true;
        }

        // Check if the user has any of the required roles
        if (!requiredRoles.includes(userRole)) {
            this.router.navigate(['/access-denied']);
            return false;
        }

        return true;
    }
}
